import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../../../Components/Common/Breadcrumb";

const COVERDASH_URL =
  "https://quotes.coverdash.com/v2/partner-cobrand/2383391e-c16a-4745-80fd-59418539a46c";

const CoverdashQuotes: React.FC = () => {
  document.title = "Business Insurance Quotes | BizServe";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Insurance"
            breadcrumbItem="Get a Quote"
          />

          <div
            className="rounded overflow-hidden border bg-light"
            style={{ minHeight: "calc(100vh)", width: "100%" }}
          >
            <iframe
              src={COVERDASH_URL}
              title="Coverdash Business Insurance Quotes"
              style={{
                width: "100%",
                height: "calc(100vh - 180px)",
                minHeight: "100vh",
                border: "none",
                display: "block",
              }}
              referrerPolicy="no-referrer"
              allowFullScreen
            />
          </div>

          <p className="mt-2 text-muted small mb-0">
            If the form above is blank,{" "}
            <a
              href={COVERDASH_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              click here
            </a>
            {" "}to complete your quote.
          </p>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CoverdashQuotes;
